import React, { useState } from 'react';
import { Triangle, Eye, EyeOff, ArrowRight, Github, Loader2 } from 'lucide-react';
interface LoginPageProps {
  onLogin: () => void;
  onGoToRegister: () => void;
}
export function LoginPage({
  onLogin,
  onGoToRegister
}: LoginPageProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [rememberMe, setRememberMe] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      onLogin();
    }, 1200);
  };
  return <div className="min-h-screen bg-astro-dark text-white font-sans selection:bg-astro-green selection:text-black flex flex-col" data-id="element-1429">
      {/* Navbar */}
      <nav className="sticky top-0 z-50 bg-astro-dark/80 backdrop-blur-md border-b border-astro-border h-16" data-id="element-1430">
        <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between" data-id="element-1431">
          <div className="flex items-center gap-2 cursor-pointer" onClick={onGoToRegister} data-id="element-1432">
            <Triangle className="text-astro-green fill-astro-green" size={24} strokeWidth={2.5} data-id="element-1433" />
            <span className="text-xl font-bold text-white tracking-tight" data-id="element-1434">
              Astrolayb
            </span>
          </div>
          <button onClick={onGoToRegister} className="text-sm font-medium text-astro-text-secondary hover:text-white transition-colors" data-id="element-1435">
            Create account
          </button>
        </div>
      </nav>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center p-6" data-id="element-1436">
        <div className="w-full max-w-md" data-id="element-1437">
          <div className="text-center mb-8" data-id="element-1438">
            <h1 className="text-3xl font-bold mb-2" data-id="element-1439">Welcome back</h1>
            <p className="text-astro-text-secondary" data-id="element-1440">
              Sign in to your Astrolayb account
            </p>
          </div>

          <div className="bg-astro-card border border-astro-border rounded-xl p-8 shadow-2xl" data-id="element-1441">
            <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1442">
              <div data-id="element-1443">
                <label className="block text-sm font-medium text-astro-text-secondary mb-1.5" data-id="element-1444">
                  Email
                </label>
                <input type="email" placeholder="jane@company.com" className="w-full bg-[#0a0e14] border border-astro-border rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-astro-text-secondary/50 focus:outline-none focus:border-astro-green/50 transition-colors" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} data-id="element-1445" />
              </div>

              <div data-id="element-1446">
                <div className="flex items-center justify-between mb-1.5" data-id="element-1447">
                  <label className="block text-sm font-medium text-astro-text-secondary" data-id="element-1448">
                    Password
                  </label>
                  <button type="button" className="text-xs text-astro-green hover:text-astro-green-dark transition-colors font-medium" data-id="element-1449">
                    Forgot password?
                  </button>
                </div>
                <div className="relative" data-id="element-1450">
                  <input type={showPassword ? 'text' : 'password'} placeholder="••••••••" className="w-full bg-[#0a0e14] border border-astro-border rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-astro-text-secondary/50 focus:outline-none focus:border-astro-green/50 transition-colors pr-10" value={formData.password} onChange={e => setFormData({
                  ...formData,
                  password: e.target.value
                })} data-id="element-1451" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-astro-text-secondary hover:text-white transition-colors" data-id="element-1452">
                    {showPassword ? <EyeOff size={16} data-id="element-1453" /> : <Eye size={16} data-id="element-1454" />}
                  </button>
                </div>
              </div>

              {/* Remember Me */}
              <div className="flex items-center gap-2" data-id="element-1455">
                <button type="button" onClick={() => setRememberMe(!rememberMe)} className={`w-4 h-4 rounded border flex items-center justify-center transition-colors shrink-0 ${rememberMe ? 'bg-astro-green border-astro-green' : 'border-astro-border hover:border-white/30'}`} data-id="element-1456">
                  {rememberMe && <svg width="10" height="8" viewBox="0 0 10 8" fill="none" className="text-black" data-id="element-1457">
                      <path d="M1 4L3.5 6.5L9 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-1458" />
                    </svg>}
                </button>
                <span className="text-sm text-astro-text-secondary" data-id="element-1459">
                  Remember me
                </span>
              </div>

              <button type="submit" disabled={isLoading} className="w-full py-3 bg-astro-green text-black font-bold rounded-lg hover:bg-astro-green-dark transition-colors shadow-[0_0_20px_rgba(34,197,94,0.2)] flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-1460">
                {isLoading ? <>
                    <Loader2 size={18} className="animate-spin" data-id="element-1461" />
                    Signing in…
                  </> : <>
                    Sign In <ArrowRight size={18} data-id="element-1462" />
                  </>}
              </button>
            </form>

            <div className="relative my-6" data-id="element-1463">
              <div className="absolute inset-0 flex items-center" data-id="element-1464">
                <div className="w-full border-t border-astro-border" data-id="element-1465"></div>
              </div>
              <div className="relative flex justify-center text-xs uppercase" data-id="element-1466">
                <span className="bg-astro-card px-2 text-astro-text-secondary" data-id="element-1467">
                  Or continue with
                </span>
              </div>
            </div>

            <button type="button" className="w-full py-2.5 border border-astro-border text-white font-medium rounded-lg hover:bg-white/5 transition-colors flex items-center justify-center gap-2" data-id="element-1468">
              <Github size={18} data-id="element-1469" /> Sign in with GitHub
            </button>

            <p className="mt-6 text-center text-sm text-astro-text-secondary" data-id="element-1470">
              Don't have an account?{' '}
              <button onClick={onGoToRegister} className="text-astro-green hover:underline font-medium" data-id="element-1471">
                Sign up free
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>;
}